// removed by extract-text-webpack-plugin
module.exports = {"container":"_3NN86","borders":"_3Fo1w","flexContainer":"_3EQdU","input":"BgZr0","close":"emXCq","closeIcon":"_3CAky"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/toolbar-input.scss
// module id = 771
// module chunks = 3 4 5 6 7